<template>
  <div class="hotline-management">
    <el-form :model="form" label-width="80px" class="header">
        <el-form-item label="热线名称">
            <el-input v-model="form.Name" placeholder="请输入热线名称"></el-input>
        </el-form-item>
        <el-form-item label-width="20px">
            <el-button type="primary" @click="handleCurrentChange(1)">查询</el-button>
            <el-button type="primary" @click="reset">重置</el-button>
            <el-button type="primary" @click="AddHotline">添加热线</el-button>
        </el-form-item>
    </el-form>
    <div class="table-container" v-loading="HotlineListloading">
      <el-table :data="HotlineList" style="width: 100%;margin-top: 20px;"> 
        <el-table-column prop="materialName" label="热线名称"></el-table-column>
        <el-table-column prop="status" label="状态"></el-table-column>
        <el-table-column prop="createdDate" label="创建时间"></el-table-column>
        <el-table-column prop="creator" label="创建人"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="EditHotline(scope.row)">编辑</el-button>
            <el-popconfirm title="确定删除本条记录吗？" @confirm="deleteHotline(scope.row.materialKey)">
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
        :current-page="form.PageIndex"
        :page-size="form.PageSize"
        :total="form.total"
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="添加热线" width="800px">
      <el-form label-width="80px" class="dialog-form">
        <el-form-item label="热线名称">
          <el-input v-model="Name" placeholder="请输入热线名称"></el-input>
        </el-form-item>
        <el-form-item label="热线内容">
          <UEtext :defaultMsg=defaultMsg ref="ue"></UEtext>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" @click="submit" :loading="submitLoading">保存</el-button>
          <el-button type="primary" @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import UEtext from '@/components/text.vue';
export default {
  components: { UEtext },
  data() {
    return {
      form: {
        Name: '',
        phone: '',
        PageIndex: 1,
        PageSize: 10,
        total: 0,
        HotlineFlag:1,
        Status:'',
        MaterialType:'',
        ItemName:'',
        StartTime:'',
        EndTime:'',
        RoleID:sessionStorage.getItem('RoleID'),
        ExcelFlag:'0'
      },
      defaultMsg:'',
      HotlineList: [],
      dialogVisible:false,
      HotlineListloading:false,
      Name:'',
      materialKey:'',
      submitLoading:false
    };
  },
  watch:{
    dialogVisible(val){
      if(!val){
        this.Name = '';
        this.defaultMsg = '';
        this.materialKey='';
      }
    }
  },
  mounted() {
    this.Init();
  },
  methods: {
    Init() {
      this.HotlineListloading = true;
      this.$Http_Post('/management/getContentDistribution', this.form).then(res => {
        this.HotlineListloading = false;
        if(res.Code == 200){
          this.HotlineList = res.Data;
        }else{
          this.$message.error(res.Message);
        }
      });
    },
    reset(){
      this.form=this.$options.data().form;
      this.Init();
    },
    handleCurrentChange(item){
      this.form.PageIndex = item;
      this.Init();
    },
    deleteHotline(materialKey){
      this.$Http_Post('/management/materialDel', {MaterialKey:materialKey}).then(res => {
        if(res.Code == 200){
          this.$message.success('删除成功');
          this.Init();
        }else{
          this.$message.error(res.Message);
        }
      });
    },
    EditHotline(row){
      this.$Http_Post('management/getContentDetails', { MaterialKey: row.materialKey }).then((res) => {
        if(res.Code == 200 || res.Code == 0){
          this.materialKey = res.Data.materialKey;
          this.Name = res.Data.materialName;
          this.dialogVisible = true;
          setTimeout(() => {
            this.defaultMsg = res.Data.richTextContent;
          }, 500);
        }else{
          this.$message.error(res.Message);
        }
      });
    },
    AddHotline(){
      this.dialogVisible = true;
      this.defaultMsg = '';
      this.Name='';
    },
    submit(){
      if(!this.Name){
        this.$message.error('请输入热线名称');
        return;
      }
      if(!this.$refs.ue.getUEContent()){
        this.$message.error('请输入热线内容');
        return;
      }
      this.submitLoading = true;
      var from = new FormData();
      if(this.materialKey){//修改
        from.append('MaterialKey', this.materialKey);
        from.append('RoleID',sessionStorage.getItem('RoleID'));
      }
      from.append('fileName', '');
      from.append('MaterialName', this.Name);
      from.append('Label','');
      from.append('ItemKey','');
      from.append('Type', 1);
      from.append('Purpose','');
      from.append('LineNumber','');
      from.append('IsActive',1);
      from.append('CopyrightStatement', '');
      from.append('CodeSnippet',this.$refs.ue.getUEContent());
      from.append('ScheduledRelease','');
      from.append('HotlineFlag',1);
      this.$Http_Post('management/articlePublishing', from, { 'Content-Type': 'multipart/form-data', }).then(res => {
        this.submitLoading = false;
        if(res.Code == 200){
          this.$message.success('添加成功');
          this.dialogVisible = false;
          this.Name = '';
          this.Init();
        }else{
          this.$message.error(res.Message);
        }
      });
    }
  },
};
</script>

<style>
.hotline-management .header {background: #fff;padding: 20px 0 0;}
.hotline-management .el-form-item {margin-bottom: 20px;display: inline-block;}
.hotline-management .table-container {background: #fff;padding: 20px;margin-top: 20px;}
.hotline-management .dialog-form .el-form-item__content{line-height: 1!important;}
</style>

